export default "__VITE_ASSET__1409b87a__"